module.exports = __webpack_public_path__ + "static/img/TestRecords-active.ec9e3d82.svg";